export default function Modal() {
    return {
        MuiModal: {
            styleOverrides: {
                backdrop: {
                    background: `rgba(0,0,0,0.5)`
                }
            }
        }
    };
}
